/**
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface ModuleManifest { 
    tingsSchema?: ModuleManifest;
    /**
     * Eindeutige Modul-ID
     */
    moduleId: string;
    /**
     * Semantische Version
     */
    version: string;
    /**
     * Anzeigename
     */
    name: string;
    moduleType: ModuleManifest.ModuleTypeEnum;
    /**
     * Kategorie des Moduls (z.B. CHECKER, ACTION)
     */
    category: string;
    /**
     * Kurzbeschreibung
     */
    description?: string;
    /**
     * Icon-Bezeichner für die UI
     */
    icon?: string;
    /**
     * JSON-Schema der erwarteten Eingabedaten
     */
    inputSchema?: { [key: string]: any; };
    /**
     * JSON-Schema der statischen Konfigurationsparameter (Builder-Settings)
     */
    settingsSchema?: { [key: string]: any; };
    /**
     * JSON-Schema der Ausgabedaten
     */
    outputSchema?: { [key: string]: any; };
    /**
     * Service-Bus-Topic für die Ausführung
     */
    executionTarget?: string;
}
export namespace ModuleManifest {
    export type ModuleTypeEnum = 'INTERN' | 'PRUEFREGEL' | 'WORKFLOW';
    export const ModuleTypeEnum = {
        INTERN: 'INTERN' as ModuleTypeEnum,
        PRUEFREGEL: 'PRUEFREGEL' as ModuleTypeEnum,
        WORKFLOW: 'WORKFLOW' as ModuleTypeEnum
    };
}